import React from "react";
import CommonGrid from "./CommonGrid";
import { ColumnType } from "../../../../components/Grid/constants";
import { RequestState, RequestStateRaw } from "../../enum";
import { displayHowManyDaysLeft, showProp, isOfficialAdmin } from "../../CroUtils";
import AssigneeDropdown from "../AssigneeDropdown";

const RequestGrid = function(props) {
  var onAssign = props.onAssign;
  var assignees = props.assignees;
  var auth = props.auth;
  var admin = auth && isOfficialAdmin(auth);

  var rest = Object.assign({}, props);
  delete rest.auth;
  delete rest.onAssign;

  var columns = [
    {
      field: "firstName",
      displayField: "person",
      label: "Jméno žadatele",
      type: ColumnType.TEXT,
      mapper: (field) => (field ? field.firstName : ""),
      width: "12%",
    },
    {
      field: "lastName",
      displayField: "person",
      label: "Příjmení žadatele",
      type: ColumnType.TEXT,
      mapper: (field) => (field ? field.lastName : ""),
      width: "12%",
    },
    {
      sortable: false,
      filterable: true,
      field: "officialFullName",
      displayField: "officials",
      label: "Funkcionáři",
      type: ColumnType.TEXT,
      mapper: (field) =>
        `${field && field[0] ? field[0]["firstName"] : ""} ${showProp(field, "lastName")}`,
      width: "24%",
    },
    // {
    //   field: 'officialFirstName',
    //   label: 'Jméno funkcionáře',
    //   type: ColumnType.TEXT,
    //   display: false
    // },
    // {
    //   field: 'officialLastName',
    //   label: 'Příjmení funkcionáře',
    //   type: ColumnType.TEXT,
    //   display: false
    // },
    {
      field: "state.name",
      displayField: "state",
      label: "Stav",
      enum: RequestState,
      type: ColumnType.ENUM,
      mapper: (field) =>
        typeof field === "object" && field ? field.name : field || "",
      width: "8%",
    },
    {
      sortable: false,
      field: "period",
      label: "Lhůta",
      type: ColumnType.JSX,
      jsx: (row) =>
        displayHowManyDaysLeft(row.created, row.state === RequestStateRaw.NEW),
      width: "8%",
    },
    {
      field: "created",
      label: "Vytvořen",
      type: ColumnType.DATE,
      width: "8%",
    },
  ];

  if (admin) {
    columns.push({
      field: "assignedTo.name",
      displayField: "assignedTo",
      label: "Vyřizuje",
      type: ColumnType.JSX,
      sortable: false,
      filterable: true,
      width: "18%",
      jsx: function(row) {
        var currentId = row.assignedTo ? row.assignedTo.id : '';
        return (
            <AssigneeDropdown
                value={currentId}
                assignees={assignees}
                onChange={function(assigneeId) {
                  if (onAssign) onAssign(row.id, assigneeId);
                }}
            />
        );
      },
    });
  } else {
    columns.push({
      field: "assignedTo.name",
      displayField: "assignedTo",
      label: "Vyřizuje",
      type: ColumnType.TEXT,
      mapper: function(field) { return field ? field.name : ""; },
      width: "10%",
    });
  }

  columns.push({
    field: "assignedDate",
    label: "Datum přidělení",
    type: ColumnType.DATE,
    width: "8%",
  });

  columns.push({
    field: "processingDate",
    label: "Vyřešeno",
    type: ColumnType.DATE,
    width: "8%",
  });

  return <CommonGrid {...rest} columns={columns} />;
};

export default RequestGrid;

export const RequestPublic = (props) => {
  const columns = [
    {
      sortable: false,
      field: "text",
      label: "Text",
      type: ColumnType.TEXT,
      width: "70%",
    },
    {
      field: "state.name",
      displayField: "state",
      label: "Stav",
      enum: RequestState,
      type: ColumnType.ENUM,
      width: "15%",
    },
    {
      field: "created",
      label: "Vytvořen",
      type: ColumnType.DATE,
      width: "15%",
    },
  ];

  return <CommonGrid {...props} columns={columns} />;
};